import styled from "styled-components";

import { COLORS, FONT_WEIGHT } from "../../../../constants/Styles";

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 1.5rem;
`;

const Label = styled.label`
  display: flex;
  width: 100%;
`;

const Name = styled.div`
  flex: 1;
  margin-left: 1rem;
  font-weight: ${FONT_WEIGHT.weight500};
  display: flex;
  align-items: center;
`;

const ShipDays = styled.div`
  color: ${COLORS.secondaryLight};
  margin-left: 0.5rem;
  font-weight: ${FONT_WEIGHT.weight200};
`;

const Currency = styled.div`
  margin-left: 1rem;
`;

export { Container, Label, Name, Currency, ShipDays };
